import { httpClient } from '@/services/http/httpClient'

export async function endAccess() {
  return await httpClient.delete('/users/sessions/current')
}
